import React from 'react';

import PropTypes from 'prop-types';
import useStyles from './Card.styled';
import Box from '@material-ui/core/Box';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

const TotalCard = ({ children, label, count, color, customClasses, onClick, showLinkButton }) => {
  const classes = useStyles();

  return (
    <Box className={`${classes.container} ${classes[color]} ${customClasses?.container || ''}`}>
      <Box display="flex" alignItems="center">
        <div className={`${classes.widgetIcon} ${classes[color + 'Icon']}`}>{children}</div>
        <div className={`${classes.data} ${color}`}>
          <div className={classes.widgetContent}>
            <span className={classes.widgetValue}>{count}</span>
            <span className={classes.widgetLabel}>{label}</span>
          </div>
        </div>
      </Box>
      {showLinkButton && (
        <Box className={classes.showButton} onClick={onClick}>
          <Box display="flex" alignItems="center">
            <span className={classes.showButtonLabel}>Show</span>
            <ArrowForwardIcon className={classes.showButtonIcon} />
          </Box>
        </Box>
      )}
    </Box>
  );
};

TotalCard.propTypes = {
  count: PropTypes.any.isRequired,
  label: PropTypes.string.isRequired,
  children: PropTypes.any.isRequired,
  customClasses: PropTypes.object.isRequired,
};

TotalCard.defaultProps = {
  count: 0,
  label: '',
  color: 'primary',
  customClasses: {},
  onClick: () => {},
  showLinkButton: false,
};

export default TotalCard;
